import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import { compile } from "@bd-utils/handlerbars-helper";
import {
  getBlockCorrectAnswerStrings,
  getBuildingBlockAnswer,
} from "@bd-stores/game-data";
import {
  maybeUpdateBuildingBlockStatus,
  updateFinalBuildingBlockAnswer,
  setGameStartedAt,
  setGameScreenPopup,
  getFinalBuildingBlockAnswers,
  updateTimeoutBuildingBlockAnswers,
  getTimeoutBuildingBlockAnswers,
} from "@bd-core/firebase-actions";
import CONFIG from "@bd-core/config";
import bdjs from "@bd-core/bdjs";
import BD_GAME_LOGIC from "../core/game-logic";
import { updateStatusBarTime } from "../utils/live-time";
import Store_Storage from "@bd-components/store-storage";

export class Block_Puzzle extends BD_Block {
  constructor() {
    super();

    this.type = "puzzle";
    this.templateID = "puzzle-template";

    this.elms = {
      inputAnswer: ".js-input-answer",
      submitBtn: ".js-submit-btn",
      questionBox: ".js-question-box",
      dockItem: ".macos-dock__item",
      desktopFolder: ".desktop-folder",
      restrictedBannerDock: ".apps-restricted-banner.is-dock",
      restrictedBannerSidebar: ".apps-restricted-banner.is-sidebar",
      closeError: ".js-close-error",
      startGameBtn: ".js-start-game",
      startGameText: ".js-start-game-text",
      startOverlay: ".js-start-overlay",
      timeoutPopup: ".js-puzzle-timeout",
      timeoutInputAnswer: ".js-timeout-input-answer",
      timeoutSubmitBtn: ".js-timeout-submit-btn",
      timeoutQuestionBox: ".js-timeout-question-box",
      timeoutCloseError: ".js-timeout-close-error",
      timeoutCodeSlots: ".js-timeout-code-slots",
      completeOverlay: ".js-complete-overlay",
      teamCompleteBtn: ".js-team-complete",
    };

    this._events = this.getEvents();
    this.codeBuffer = [];
    this.activeCursorIndex = 0;
    this.answerLength = 8;

    this.timeoutCodeBuffer = Array(8).fill("");
    this.timeoutActiveCursorIndex = 0;
    this.isTimeoutActive = false;
    this._originalOnTimeOut = null;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "input",
        selector: elms.inputAnswer,
        handler: this.onInputAnswer,
      },
      {
        event: "click",
        selector: elms.submitBtn,
        handler: this.onSubmitAnswer,
      },
      {
        event: "click",
        selector: elms.dockItem,
        handler: this.onDockItemClick,
      },
      {
        event: "click",
        selector: elms.desktopFolder,
        handler: this.onFolderClick,
      },
      {
        event: "click",
        selector: elms.closeError,
        handler: this.onCloseError,
      },
      {
        event: "click",
        selector: elms.startGameBtn,
        handler: this.onStartGame,
      },
      {
        event: "input",
        selector: elms.timeoutInputAnswer,
        handler: this.onTimeoutInputAnswer,
      },
      {
        event: "click",
        selector: elms.timeoutSubmitBtn,
        handler: this.onTimeoutSubmitAnswer,
      },
      {
        event: "click",
        selector: elms.timeoutCloseError,
        handler: this.onTimeoutCloseError,
      },
      {
        event: "click",
        selector: elms.teamCompleteBtn,
        handler: this.onTeamComplete,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.deferAnswerDependentInit();
    this.setGameState();
  }

  beforeDestroy() {
    if (this._onAnswersReady) {
      $(document).off("bd__buildingBlocksAnswersReady", this._onAnswersReady);
      this._onAnswersReady = null;
    }

    $(document).off("click.puzzle-focus");
    $(document).off("keydown.puzzle-keys");
    $(".js-code-slots").off("click");
    $(document).off("click.timeout-focus");
    $(document).off("keydown.timeout-keys");
    $(".js-timeout-code-slots").off("click");

    // if (this._bannerTimeout) {
    //   clearTimeout(this._bannerTimeout);
    // }

    if (this._originalOnTimeOut) {
      BD_GAME_LOGIC.onTimeOut = this._originalOnTimeOut;
      this._originalOnTimeOut = null;
    }

    // $(".gameScreen.is-puzzle").removeClass("is-timeout-active");
  }

  modifyData() {
    const { id } = this._data;
    const allBuildingBlocks = Object.values(CONFIG.building_blocks);
    const currentBuildingBlock = allBuildingBlocks.find(
      // @ts-ignore
      (block) => block.id === id,
    );
    const currentBuildingBlockIndex =
      allBuildingBlocks.indexOf(currentBuildingBlock);
    const totalBuildingBlocks = allBuildingBlocks.length;
    this._data.currentBuildingBlockIndex = currentBuildingBlockIndex;
    this._data.totalBuildingBlocks = totalBuildingBlocks;

    const isTimeoutCodeDifferent =
      CONFIG.game_options.timer_config.is_timeout_code_different;
    if (isTimeoutCodeDifferent) {
      const timeoutCode = CONFIG.game_options.timer_config.timeout_code || "";
      this._data.timeout_answers = [
        {
          id: "timeout_code",
          code_title: this._data.timeout_screen?.title || "Timeout Code",
          attempt: 99,
          answer_length: timeoutCode.length || 8,
          correct_answer: timeoutCode,
        },
      ];
    } else {
      this._data.timeout_answers = this._data.correct_answers || [];
    }

    this._data.weather_widget = CONFIG.weather_widget;

    return this._data;
  }

  render() {
    const data = this.modifyData();
    const htmlTemplate = $("#" + this.templateID).html();
    const html = compile(htmlTemplate, data);
    $("#templateWrapper").html(html);
    updateStatusBarTime();
    this.setGameState();
  }

  setGameState() {
    const $screen = $(".gameScreen.is-puzzle");
    $screen.addClass("is-init");

    const blockID = this._data.id;
    getFinalBuildingBlockAnswers(blockID).then((answers) => {
      // this.finalCorrectAnswers = answers.val() || {};
      // this.applySavedAnswersToUI();
      const finalCorrectAnswers = answers.val();
      const $rows = $(".js-puzzle-row");

      $.each($rows, (index, row) => {
        const rowId = $(row).attr("data-id");
        const $row = $(row);
        const isHasAnswer = finalCorrectAnswers[String(rowId)];
        if (isHasAnswer) {
          const $codeSlots = $row.find(".js-code-slots");
          const answer = finalCorrectAnswers[String(rowId)];
          if (answer) {
            const answerArray = answer.split("");
            $.each(answerArray, (idx, slot) => {
              const $slot = $codeSlots.find(
                `.js-code-input-slot[data-index="${String(idx)}"]`,
              );
              $slot.addClass("is-filled is-correct-number");
              $slot.find(".puzzle__item__code-char").text(slot);
            });
          }
          $row.addClass("is-completed");
        }

        const attempts = this.getTotalAttempts(rowId);
        $row.find(".js-attempts-count").text(attempts);
      });

      // Restore complete popup on reload if all codes are already answered
      if (
        $rows.length &&
        $rows.length === $rows.filter(".is-completed").length
      ) {
        this.showCompletePopup();
      }
    });

    const storage = new Store_Storage(CONFIG.GP); // see store-storage.js
    storage.load();
    const isOpenGameScreenPopup = storage.state.isGameScreenPopup;

    // Show start overlay
    $(this.elms.startOverlay).toggleClass("is-active", !isOpenGameScreenPopup);

    if (isOpenGameScreenPopup) {
      const $screen = $(".gameScreen.is-puzzle");
      $screen.removeClass("is-init").addClass("is-intro");
      setTimeout(() => {
        $screen.removeClass("is-intro").addClass("is-playing");
      }, 1300);
    }

    // Hook timeout (setGameState runs twice via render + beforeInit)
    if (!this._originalOnTimeOut) {
      this._originalOnTimeOut = BD_GAME_LOGIC.onTimeOut.bind(BD_GAME_LOGIC);
      BD_GAME_LOGIC.onTimeOut = this.handlePuzzleTimeout.bind(this);
    }

    if (CONFIG.user_progress.is_timeout) {
      this.handlePuzzleTimeout();
    }
  }

  applySavedAnswersToUI() {
    const finalCorrectAnswers = this.finalCorrectAnswers || {};

    // Apply to main puzzle rows
    const $rows = $(".js-puzzle-row");
    if ($rows.length > 0) {
      $.each($rows, (index, row) => {
        const rowId = $(row).attr("data-id");
        const $row = $(row);
        const isHasAnswer = finalCorrectAnswers[String(rowId)];
        if (isHasAnswer) {
          const $codeSlots = $row.find(".js-code-slots");
          const answer = finalCorrectAnswers[String(rowId)];
          if (answer) {
            const answerArray = answer.split("");
            $.each(answerArray, (idx, slot) => {
              const $slot = $codeSlots.find(
                `.js-code-input-slot[data-index="${String(idx)}"]`,
              );
              $slot.addClass("is-filled is-correct-number");
              $slot.find(".puzzle__item__code-char").text(slot);
            });
          }
          $row.addClass("is-completed");
        }

        const attempts = this.getTotalAttempts(rowId);
        $row.find(".js-attempts-count").text(attempts);
      });
    }

    // Apply to timeout puzzle rows
    if (this.timeoutRowsData && this.timeoutRowsData.length > 0) {
      const $timeoutRows = $(".js-timeout-puzzle-row");
      $.each($timeoutRows, (index, row) => {
        const rowId = $(row).attr("data-id");
        const $row = $(row);
        const rowIndex = parseInt($row.attr("data-row-index"), 10);
        const isHasAnswer = finalCorrectAnswers[String(rowId)];
        if (isHasAnswer && this.timeoutRowsData[rowIndex]) {
          this.timeoutRowsData[rowIndex].isCompleted = true;
          const answer = finalCorrectAnswers[String(rowId)];
          if (answer) {
            this.timeoutRowsData[rowIndex].buffer = answer.split("");
            const $codeSlots = $row.find(".js-timeout-code-slots");
            $.each(this.timeoutRowsData[rowIndex].buffer, (idx, slot) => {
              const $slot = $codeSlots.find(
                `.js-timeout-code-input-slot[data-index="${String(idx)}"]`,
              );
              $slot.addClass("is-filled is-correct-number");
              $slot.find(".puzzle-timeout__code-char").text(slot);
            });
          }
          $row.addClass("is-completed");
        }

        const attempts = this.getTotalAttempts(rowId);
        if (this.timeoutRowsData[rowIndex]) {
          this.timeoutRowsData[rowIndex].attempts = attempts;
        }
      });
    }
  }

  hasBlockAnswers() {
    return getBlockCorrectAnswerStrings(this._data.id).length > 0;
  }

  getPrimaryCorrectCode() {
    const isTimeoutCodeDifferent =
      CONFIG.game_options.timer_config.is_timeout_code_different;

    if (isTimeoutCodeDifferent) {
      return CONFIG.game_options.timer_config.timeout_code || "";
    }

    return getBlockCorrectAnswerStrings(this._data.id)[0] || "";
  }

  deferAnswerDependentInit() {
    const isTimeoutCodeDifferent =
      CONFIG.game_options.timer_config.is_timeout_code_different;

    if (isTimeoutCodeDifferent) {
      this.initTimeoutPopup();
    }

    const runAnswerDependent = () => {
      this.initSlots();
      if (!isTimeoutCodeDifferent) {
        this.initTimeoutPopup();
      }
    };

    if (this.hasBlockAnswers()) {
      runAnswerDependent();
      return;
    }

    this._onAnswersReady = () => {
      if (!this.hasBlockAnswers()) return;

      $(document).off("bd__buildingBlocksAnswersReady", this._onAnswersReady);
      this._onAnswersReady = null;
      runAnswerDependent();
    };

    bdjs.listen("bd__buildingBlocksAnswersReady", this._onAnswersReady);

    // Firebase init finishes before block render; answers may already be in Redux.
    this._onAnswersReady();
  }

  getTotalAttempts(rowId) {
    const codes = this._data.correct_answers;
    const submitAttemptsTotal = this.getSubmitAttemptsTotal(rowId);
    const codeMaxAttempts = codes.find((code) => code.id === rowId).attempt;
    const attemptsLeft = codeMaxAttempts - submitAttemptsTotal;

    return attemptsLeft < 0 ? 0 : attemptsLeft;
  }

  initSlots() {
    const correctAnswers = this._data.correct_answers;
    const firstCorrectAnswer = correctAnswers[0].answer_length;
    this.answerLength = firstCorrectAnswer?.length || 8;

    this.rowsData = [];
    for (let i = 0; i < correctAnswers.length; i++) {
      const rowId = correctAnswers[i].id;
      this.rowsData.push({
        buffer: Array(this.answerLength).fill(""),
        cursorIndex: 0,
        attempts: this.getTotalAttempts(rowId),
        isCompleted: false,
      });
    }
    this.activeRowIndex = 0;

    $(this.elms.inputAnswer).attr("maxlength", this.answerLength);

    const self = this;
    // Register click event on visual slots inside rows wrapper
    $(".js-puzzle-rows").on("click", ".puzzle__item__code-slot", function (e) {
      if (!$(".gameScreen.is-puzzle").hasClass("is-playing")) {
        return;
      }
      e.stopPropagation();
      const rowIndex = parseInt(
        $(this).closest(".js-puzzle-row").attr("data-row-index"),
        10,
      );
      if (self.rowsData[rowIndex].isCompleted) return;

      self.activeRowIndex = rowIndex;
      self.rowsData[rowIndex].cursorIndex = parseInt(
        $(this).attr("data-index"),
        10,
      );
      $(self.elms.inputAnswer).val(self.rowsData[rowIndex].buffer.join(""));
      if ($(self.elms.inputAnswer)[0]) {
        $(self.elms.inputAnswer)[0].focus({ preventScroll: true });
      }
      self.updateCodeSlots();
    });

    // Focus / Blur styling helpers
    $(this.elms.inputAnswer).on("focus blur", () => {
      this.updateCodeSlots();
    });

    // Handle document click to refocus/defocus
    $(document).on("click.puzzle-focus", (e) => {
      const isInsidePuzzle = $(e.target).closest(".puzzle__item").length > 0;
      const isOverlayActive =
        $(e.target).closest(".puzzle__item__overlay").length > 0;
      const isButton = $(e.target).closest("button, .js-continue").length > 0;

      if (isButton) {
        // Let the button click handlers manage focus/blur themselves
        return;
      }

      if (
        isInsidePuzzle &&
        !isOverlayActive &&
        $(".gameScreen.is-puzzle").hasClass("is-playing")
      ) {
        const rowData = this.rowsData[this.activeRowIndex];
        let firstEmpty = rowData.buffer.indexOf("");
        rowData.cursorIndex =
          firstEmpty === -1 ? this.answerLength - 1 : firstEmpty;
        $(this.elms.inputAnswer).val(rowData.buffer.join(""));
        if ($(this.elms.inputAnswer)[0]) {
          $(this.elms.inputAnswer)[0].focus({ preventScroll: true });
        }
        this.updateCodeSlots();
      } else {
        $(this.elms.inputAnswer).trigger("blur");
      }
    });

    $(document).on("keydown.puzzle-keys", (e) => {
      if (!$(this.elms.inputAnswer).is(":focus")) return;

      const rowData = this.rowsData[this.activeRowIndex];
      if (rowData.isCompleted) return;

      if (e.key === "Backspace") {
        e.preventDefault();
        $(this.elms.questionBox).removeClass("is-incorrect");
        const $currentRowSlots = $(".js-puzzle-row")
          .eq(this.activeRowIndex)
          .find(".js-code-input-slot");
        if (rowData.buffer[rowData.cursorIndex] !== "") {
          $currentRowSlots
            .eq(rowData.cursorIndex)
            .removeClass("is-correct-number is-wrong-number");
          rowData.buffer[rowData.cursorIndex] = "";
        } else if (rowData.cursorIndex > 0) {
          rowData.cursorIndex--;
          $currentRowSlots
            .eq(rowData.cursorIndex)
            .removeClass("is-correct-number is-wrong-number");
          rowData.buffer[rowData.cursorIndex] = "";
        }
        $(this.elms.inputAnswer).val(rowData.buffer.join(""));
        this.updateCodeSlots();
        return;
      }

      // Handle Enter
      if (e.key === "Enter") {
        const val = rowData.buffer.join("").trim();
        if (val.length > 0) {
          e.preventDefault();
          $(".js-puzzle-row")
            .eq(this.activeRowIndex)
            .find(".js-submit-btn")
            .trigger("click");
        }
        return;
      }

      // Handle numeric key entry (0-9)
      if (/^[0-9]$/.test(e.key)) {
        e.preventDefault();
        $(this.elms.questionBox).removeClass("is-incorrect");
        const $currentRowSlots = $(".js-puzzle-row")
          .eq(this.activeRowIndex)
          .find(".js-code-input-slot");
        $currentRowSlots
          .eq(rowData.cursorIndex)
          .removeClass("is-correct-number is-wrong-number");
        rowData.buffer[rowData.cursorIndex] = e.key;
        if (rowData.cursorIndex < this.answerLength - 1) {
          rowData.cursorIndex++;
        }
        $(this.elms.inputAnswer).val(rowData.buffer.join(""));
        this.updateCodeSlots();
      }
    });

    this.updateCodeSlots();
  }

  onInputAnswer(e) {
    const elms = this.elms;
    const $input = $(e.currentTarget);
    const rowData = this.rowsData[this.activeRowIndex];
    if (rowData.isCompleted) return;

    let val = $input.val().replace(/[^0-9]/g, "");

    if (val.length > this.answerLength) {
      val = val.substring(0, this.answerLength);
    }
    $input.val(val);

    // Sync buffer
    for (let i = 0; i < this.answerLength; i++) {
      rowData.buffer[i] = val[i] || "";
    }

    let firstEmpty = rowData.buffer.indexOf("");
    rowData.cursorIndex =
      firstEmpty === -1 ? this.answerLength - 1 : firstEmpty;

    $(elms.questionBox).removeClass("is-incorrect");
    $(".js-puzzle-row")
      .eq(this.activeRowIndex)
      .find(".js-code-input-slot")
      .removeClass("is-correct-number is-wrong-number");
    this.updateCodeSlots();
  }

  updateCodeSlots() {
    const elms = this.elms;
    const isFocused = $(elms.inputAnswer).is(":focus");

    $(".js-puzzle-row").each((rowIndex, rowEl) => {
      const $row = $(rowEl);
      const isCompleted = $row.hasClass("is-completed");

      if (isCompleted) return;

      const rowData = this.rowsData[rowIndex];

      $row.find(".js-attempts-count").text(rowData.attempts);

      if (rowData.isCompleted) {
        $row.addClass("is-completed");
      }

      $row.find(".js-code-input-slot").each((index, slotEl) => {
        const $slot = $(slotEl);
        const $char = $slot.find(".puzzle__item__code-char");

        $slot.removeClass("is-filled is-active");

        const charVal = rowData.buffer[index] || "";
        if (charVal !== "") {
          $char.text(charVal);
          $slot.addClass("is-filled");
        } else {
          $char.text("");
        }

        // Highlight the slot currently being targeted for edit
        if (
          index === rowData.cursorIndex &&
          isFocused &&
          this.activeRowIndex === rowIndex
        ) {
          $slot.addClass("is-active");
        }

        if (rowData.isCompleted) {
          $slot.addClass("is-correct-number");
        }
      });
    });

    this.toggleSubmitBtn();
  }

  toggleSubmitBtn() {
    $(".js-puzzle-row").each((rowIndex, rowEl) => {
      const $row = $(rowEl);
      const $submitBtn = $row.find(".js-submit-btn");
      const rowData = this.rowsData[rowIndex];
      let isAllSlotsFilled = true;

      for (let i = 0; i < this.answerLength; i++) {
        if (rowData.buffer[i] === "") {
          isAllSlotsFilled = false;
        }
      }

      $submitBtn
        .prop("disabled", !isAllSlotsFilled || rowData.isCompleted)
        .toggleClass("is-disabled", !isAllSlotsFilled || rowData.isCompleted);
    });
  }

  getSubmitAttemptsTotal(codeID) {
    const storage = new Store_Storage(CONFIG.GP); // see store-storage.js
    storage.load();
    return storage.state.submitAttemptsTotal?.[codeID] || 0;
  }

  setSubmitAttemptsTotal(codeID) {
    const storage = new Store_Storage(CONFIG.GP); // see store-storage.js
    storage.load();

    const currentSubmitAttemptsTotal =
      storage.state.submitAttemptsTotal?.[codeID] || 0;
    const newSubmitAttemptsTotal = currentSubmitAttemptsTotal + 1;
    storage.save("submitAttemptsTotal", {
      ...storage.state.submitAttemptsTotal,
      [codeID]: newSubmitAttemptsTotal,
    });
  }

  onSubmitAnswer(e, el) {
    const elms = this.elms;
    const $this = $(el);
    const codeID = $this.parents(".js-puzzle-row").attr("data-id");
    const rowIndex = parseInt($this.attr("data-row-index"), 10);
    const rowData = this.rowsData[rowIndex];
    const answer = rowData.buffer.join("").trim().toLowerCase();

    this.setSubmitAttemptsTotal(codeID);

    if (
      $this.hasClass("is-disabled") ||
      $this.hasClass("is-loading") ||
      rowData.isCompleted
    ) {
      return;
    }

    $(elms.questionBox).removeClass("is-incorrect");
    $(elms.inputAnswer).trigger("blur");

    const blockID = this._data.id;
    let { correct_answers: correctAnswers } = getBuildingBlockAnswer(blockID);
    const theCorrectCode = correctAnswers?.[codeID] || "";
    const attemptsLeft = this.getTotalAttempts(codeID);

    const $currentRowSlots = $(".js-puzzle-row")
      .eq(rowIndex)
      .find(".js-code-input-slot");

    $currentRowSlots.each((index, slotEl) => {
      const $slot = $(slotEl);
      const charVal = rowData.buffer[index]
        ? rowData.buffer[index].toLowerCase()
        : "";
      const targetChar = theCorrectCode[index]
        ? theCorrectCode[index].toLowerCase()
        : "";

      $slot.removeClass("is-correct-number is-wrong-number");

      if (attemptsLeft === 0) {
        return;
      }

      if (charVal === targetChar && charVal !== "") {
        $slot.addClass("is-correct-number");
      } else {
        $slot.addClass("is-wrong-number");
      }
    });

    const answerCode = {
      [codeID]: answer,
    };

    if (answer === theCorrectCode) {
      rowData.isCompleted = true;
      this.updateCodeSlots();
      updateFinalBuildingBlockAnswer(blockID, answerCode).then(() => {
        this.maybeAllCodesCompleted();
      });

      $currentRowSlots.addClass("is-correct-number");
    } else {
      rowData.attempts = Math.max(0, rowData.attempts - 1);
      $(".js-puzzle-row")
        .eq(rowIndex)
        .find(".js-attempts-count")
        .text(rowData.attempts);
      $(elms.questionBox).addClass("is-incorrect");
    }

    maybeUpdateBuildingBlockStatus(blockID, "started");
  }

  maybeAllCodesCompleted() {
    // const elms = this.elms;
    const blockID = this._data.id;
    getFinalBuildingBlockAnswers(blockID).then((answers) => {
      const { correct_answers: codeAnswers } = getBuildingBlockAnswer(blockID);
      const finalAnswers = answers.val();

      if (
        !finalAnswers ||
        typeof finalAnswers !== "object" ||
        typeof codeAnswers !== "object"
      ) {
        return;
      }

      if (
        Object.keys(finalAnswers).length === Object.keys(codeAnswers).length
      ) {
        // $(elms.questionBox).addClass("is-correct");
        maybeUpdateBuildingBlockStatus(blockID, "completed").then(() => {
          this.showCompletePopup();
        });
      }
    });
  }

  onStartGame(e) {
    if (e) e.preventDefault();
    const $btn = $(this.elms.startGameBtn);
    if ($btn.hasClass("is-countdown")) return;

    $btn.addClass("is-countdown");
    $btn.find(".icon-play").hide();
    $btn.find(".icon-spinner").show();

    const self = this;

    // Start countdown animation
    this.runCountdown().then(() => {
      // Hide start overlay
      $(this.elms.startOverlay).removeClass("is-active");

      // Trigger standard intro transition
      const $screen = $(".gameScreen.is-puzzle");
      $screen.removeClass("is-init").addClass("is-intro");

      setTimeout(() => {
        $screen.removeClass("is-intro").addClass("is-playing");

        setGameScreenPopup();
        setGameStartedAt();
        self.setGameScreenPopupState();
      }, 1300);
    });
  }

  setGameScreenPopupState() {
    const storage = new Store_Storage(CONFIG.GP); // see store-storage.js
    storage.load();
    storage.save("isGameScreenPopup", 1);
  }

  runCountdown() {
    return new Promise((resolve) => {
      const $text = $(this.elms.startGameText);
      let count = 3;

      const tick = () => {
        if (count === 0) {
          resolve();
          return;
        }

        const pregame_screen = this._data.pregame_screen;
        const countdown_text = pregame_screen.button_text_count_down;
        const countdownTxt = countdown_text.replace("{count_down}", count);

        // Set countdown text matching Figma "Game Start in X"
        $text.text(countdownTxt);

        count--;
        setTimeout(tick, 1000);
      };

      tick();
    });
  }

  onCloseError(e) {
    e.preventDefault();
    $(this.elms.questionBox).removeClass("is-incorrect");
    if ($(this.elms.inputAnswer)[0]) {
      $(this.elms.inputAnswer)[0].focus({ preventScroll: true });
    }
    this.updateCodeSlots();
  }

  onDockItemClick() {
    const elms = this.elms;
    const $banner = $(elms.restrictedBannerDock);

    if (this._bannerTimeout) {
      clearTimeout(this._bannerTimeout);
    }

    $banner.addClass("is-active");

    this._bannerTimeout = setTimeout(() => {
      $banner.removeClass("is-active");
    }, 3000);
  }

  onFolderClick(e, $el) {
    const elms = this.elms;
    const $banner = $(elms.restrictedBannerSidebar);

    // Get the offset of the clicked folder relative to the questionCard__inner container
    const offset = $el.offset();
    const folderHeight = $el.outerHeight();
    const containerOffset = $(".questionCard__inner").offset() || { top: 0 };
    const relativeTop =
      offset.top - containerOffset.top + folderHeight / 2 - 20;

    if (this._sidebarBannerTimeout) {
      clearTimeout(this._sidebarBannerTimeout);
    }

    if ($banner.hasClass("is-active")) {
      // If already active, trigger hide transition first
      $banner.removeClass("is-active");

      setTimeout(() => {
        $banner.css({
          top: relativeTop + "px",
        });

        // Force browser reflow to apply top style immediately
        if ($banner.length) {
          $banner[0].offsetHeight;
        }

        $banner.addClass("is-active");
      }, 150);
    } else {
      $banner.css({
        top: relativeTop + "px",
      });
      $banner.addClass("is-active");
    }

    this._sidebarBannerTimeout = setTimeout(() => {
      $banner.removeClass("is-active");
    }, 3000);
  }

  initTimeoutPopup() {
    const isTimeoutCodeDifferent =
      CONFIG.game_options.timer_config.is_timeout_code_different;

    let timeoutAnswers = [];
    if (isTimeoutCodeDifferent) {
      const timeoutCode = CONFIG.game_options.timer_config.timeout_code || "";
      timeoutAnswers = [
        {
          id: "timeout_code",
          code_title: this._data.timeout_screen?.title || "Timeout Code",
          attempt: 99,
          answer_length: timeoutCode.length || 8,
        },
      ];
    } else {
      timeoutAnswers = this._data.correct_answers || [];
    }

    this.timeoutRowsData = [];
    for (let i = 0; i < timeoutAnswers.length; i++) {
      const answerLength = timeoutAnswers[i].answer_length || 8;
      this.timeoutRowsData.push({
        buffer: Array(answerLength).fill(""),
        cursorIndex: 0,
        attempts: timeoutAnswers[i].attempt,
        isCompleted: false,
      });
    }
    this.timeoutActiveRowIndex = 0;

    const self = this;

    // Register click event on visual slots inside timeout rows wrapper
    $(".js-timeout-puzzle-rows").on(
      "click",
      ".puzzle-timeout__code-slot",
      function (e) {
        if (!self.isTimeoutActive) return;
        e.stopPropagation();
        const rowIndex = parseInt(
          $(this).closest(".js-timeout-puzzle-row").attr("data-row-index"),
          10,
        );
        if (self.timeoutRowsData[rowIndex].isCompleted) return;

        self.timeoutActiveRowIndex = rowIndex;
        self.timeoutRowsData[rowIndex].cursorIndex = parseInt(
          $(this).attr("data-index"),
          10,
        );
        $(self.elms.timeoutInputAnswer).val(
          self.timeoutRowsData[rowIndex].buffer.join(""),
        );
        if ($(self.elms.timeoutInputAnswer)[0]) {
          $(self.elms.timeoutInputAnswer)[0].focus({ preventScroll: true });
        }
        self.updateTimeoutCodeSlots();
      },
    );

    $(this.elms.timeoutInputAnswer).on("focus blur", () => {
      this.updateTimeoutCodeSlots();
    });

    $(document).on("click.timeout-focus", (e) => {
      if (!this.isTimeoutActive) return;

      const isInsidePopup =
        $(e.target).closest(".puzzle-timeout__item").length > 0;
      const isOverlayActive =
        $(e.target).closest(".puzzle-timeout__overlay").css("opacity") === "1";
      const isButton = $(e.target).closest("button").length > 0;

      if (isButton) return;

      if (isInsidePopup && !isOverlayActive) {
        const rowData = this.timeoutRowsData[this.timeoutActiveRowIndex];
        if (rowData) {
          let firstEmpty = rowData.buffer.indexOf("");
          rowData.cursorIndex =
            firstEmpty === -1 ? rowData.buffer.length - 1 : firstEmpty;
          $(this.elms.timeoutInputAnswer).val(rowData.buffer.join(""));
          if ($(this.elms.timeoutInputAnswer)[0]) {
            $(this.elms.timeoutInputAnswer)[0].focus({ preventScroll: true });
          }
          this.updateTimeoutCodeSlots();
        }
      } else {
        $(this.elms.timeoutInputAnswer).trigger("blur");
      }
    });

    $(document).on("keydown.timeout-keys", (e) => {
      if (!this.isTimeoutActive) return;
      if (!$(this.elms.timeoutInputAnswer).is(":focus")) return;

      const rowData = this.timeoutRowsData[this.timeoutActiveRowIndex];
      if (!rowData || rowData.isCompleted) return;

      if (e.key === "Backspace") {
        e.preventDefault();
        $(this.elms.timeoutQuestionBox).removeClass("is-incorrect");
        const $currentRowSlots = $(".js-timeout-puzzle-row")
          .eq(this.timeoutActiveRowIndex)
          .find(".js-timeout-code-input-slot");
        if (rowData.buffer[rowData.cursorIndex] !== "") {
          $currentRowSlots
            .eq(rowData.cursorIndex)
            .removeClass("is-correct-number is-wrong-number");
          rowData.buffer[rowData.cursorIndex] = "";
        } else if (rowData.cursorIndex > 0) {
          rowData.cursorIndex--;
          $currentRowSlots
            .eq(rowData.cursorIndex)
            .removeClass("is-correct-number is-wrong-number");
          rowData.buffer[rowData.cursorIndex] = "";
        }
        $(this.elms.timeoutInputAnswer).val(rowData.buffer.join(""));
        this.updateTimeoutCodeSlots();
        return;
      }

      if (e.key === "Enter") {
        const val = rowData.buffer.join("").trim();
        if (val.length > 0) {
          e.preventDefault();
          $(".js-timeout-puzzle-row")
            .eq(this.timeoutActiveRowIndex)
            .find(".js-timeout-submit-btn")
            .trigger("click");
        }
        return;
      }

      if (/^[0-9]$/.test(e.key)) {
        e.preventDefault();
        $(this.elms.timeoutQuestionBox).removeClass("is-incorrect");
        const $currentRowSlots = $(".js-timeout-puzzle-row")
          .eq(this.timeoutActiveRowIndex)
          .find(".js-timeout-code-input-slot");
        $currentRowSlots
          .eq(rowData.cursorIndex)
          .removeClass("is-correct-number is-wrong-number");
        rowData.buffer[rowData.cursorIndex] = e.key;
        if (rowData.cursorIndex < rowData.buffer.length - 1) {
          rowData.cursorIndex++;
        }
        $(this.elms.timeoutInputAnswer).val(rowData.buffer.join(""));
        this.updateTimeoutCodeSlots();
      }
    });

    this.updateTimeoutCodeSlots();
  }

  handlePuzzleTimeout() {
    const $puzzle = $(".puzzle");
    const $timeout = $(this.elms.timeoutPopup);

    $puzzle.addClass("is-timeout");
    $timeout.addClass("is-active");
    $(".gameScreen.is-puzzle").addClass("is-timeout-active");
    this.isTimeoutActive = true;

    setTimeout(() => {
      // Find first uncompleted timeout row and focus it
      const firstUncompletedIndex = this.timeoutRowsData.findIndex(
        (row) => !row.isCompleted,
      );
      this.timeoutActiveRowIndex =
        firstUncompletedIndex !== -1 ? firstUncompletedIndex : 0;

      const rowData = this.timeoutRowsData[this.timeoutActiveRowIndex];
      if (rowData) {
        let firstEmpty = rowData.buffer.indexOf("");
        rowData.cursorIndex =
          firstEmpty === -1 ? rowData.buffer.length - 1 : firstEmpty;
        $(this.elms.timeoutInputAnswer).val(rowData.buffer.join(""));
      }

      $(this.elms.timeoutInputAnswer).trigger("focus");
      this.updateTimeoutCodeSlots();

      const blockID = this._data.id;
      getTimeoutBuildingBlockAnswers(blockID).then((snapshot) => {
        const timeoutAnswers = snapshot.val();
        const $timeoutRows = $(".js-timeout-puzzle-row");

        $timeoutRows.each((index, rowEl) => {
          const timeoutRowId = $(rowEl).attr("data-id");
          const $row = $(rowEl);
          const isHasAnswer = timeoutAnswers[String(timeoutRowId)];
          if (isHasAnswer) {
            const $codeSlots = $row.find(".js-timeout-code-slots");
            const timeoutAnswer = timeoutAnswers[String(timeoutRowId)];

            if (timeoutAnswer) {
              const answerArray = timeoutAnswer.split("");
              $.each(answerArray, (idx, slot) => {
                const $slot = $codeSlots.find(
                  `.js-timeout-code-input-slot[data-index="${String(idx)}"]`,
                );
                $slot.addClass("is-filled is-correct-number");
                $slot.find(".puzzle-timeout__code-char").text(slot);
              });
            }

            $row.addClass("is-completed");
          }
        });

        // Restore complete popup on reload if all timeout codes are already answered
        if (
          $timeoutRows.length &&
          $timeoutRows.length === $timeoutRows.filter(".is-completed").length
        ) {
          this.showCompletePopup();
        }
      });
    }, 500);

    if (this._originalOnTimeOut) {
      this._originalOnTimeOut();
    }
  }

  onTimeoutInputAnswer(e) {
    const $input = $(e.currentTarget);
    const rowData = this.timeoutRowsData[this.timeoutActiveRowIndex];
    if (!rowData || rowData.isCompleted) return;

    const answerLength = rowData.buffer.length;
    let val = $input.val().replace(/[^0-9]/g, "");

    if (val.length > answerLength) {
      val = val.substring(0, answerLength);
    }
    $input.val(val);

    for (let i = 0; i < answerLength; i++) {
      rowData.buffer[i] = val[i] || "";
    }

    let firstEmpty = rowData.buffer.indexOf("");
    rowData.cursorIndex = firstEmpty === -1 ? answerLength - 1 : firstEmpty;

    $(this.elms.timeoutQuestionBox).removeClass("is-incorrect");
    $(".js-timeout-puzzle-row")
      .eq(this.timeoutActiveRowIndex)
      .find(".js-timeout-code-input-slot")
      .removeClass("is-correct-number is-wrong-number");
    this.updateTimeoutCodeSlots();
  }

  updateTimeoutCodeSlots() {
    const isFocused = $(this.elms.timeoutInputAnswer).is(":focus");

    $(".js-timeout-puzzle-row").each((rowIndex, rowEl) => {
      const $row = $(rowEl);
      const isCompleted = $row.hasClass("is-completed");

      if (isCompleted) return;

      const rowData = this.timeoutRowsData[rowIndex];
      if (!rowData) return;

      if (rowData.isCompleted) {
        $row.addClass("is-completed");
      }

      $row.find(".js-timeout-code-input-slot").each((index, slotEl) => {
        const $slot = $(slotEl);
        const $char = $slot.find(".puzzle-timeout__code-char");

        $slot.removeClass("is-filled is-active");

        const charVal = rowData.buffer[index] || "";
        if (charVal !== "") {
          $char.text(charVal);
          $slot.addClass("is-filled");
        } else {
          $char.text("");
        }

        if (
          index === rowData.cursorIndex &&
          isFocused &&
          this.timeoutActiveRowIndex === rowIndex
        ) {
          $slot.addClass("is-active");
        }

        if (rowData.isCompleted) {
          $slot.addClass("is-correct-number");
        }
      });
    });

    this.toggleTimeoutSubmitBtn();
  }

  toggleTimeoutSubmitBtn() {
    $(".js-timeout-puzzle-row").each((rowIndex, rowEl) => {
      const $row = $(rowEl);
      const $submitBtn = $row.find(".js-timeout-submit-btn");
      const rowData = this.timeoutRowsData[rowIndex];
      if (!rowData) return;

      const answerLength = rowData.buffer.length;
      let isAllSlotsFilled = true;

      for (let i = 0; i < answerLength; i++) {
        if (rowData.buffer[i] === "") {
          isAllSlotsFilled = false;
        }
      }

      $submitBtn
        .prop("disabled", !isAllSlotsFilled || rowData.isCompleted)
        .toggleClass("is-disabled", !isAllSlotsFilled || rowData.isCompleted);
    });
  }

  onTimeoutSubmitAnswer(e, el) {
    const $this = $(el);
    const codeID = $this.parents(".js-timeout-puzzle-row").attr("data-id");
    const rowIndex = parseInt($this.attr("data-row-index"), 10);
    const rowData = this.timeoutRowsData[rowIndex];
    if (!rowData) return;

    const answer = rowData.buffer.join("").trim().toLowerCase();

    if (
      $this.hasClass("is-disabled") ||
      $this.hasClass("is-loading") ||
      rowData.isCompleted
    ) {
      return;
    }

    $(this.elms.timeoutQuestionBox).removeClass("is-incorrect");
    $(this.elms.timeoutInputAnswer).trigger("blur");

    const blockID = this._data.id;
    let { correct_answers: correctAnswers } = getBuildingBlockAnswer(blockID);
    const targetCode = correctAnswers?.[codeID] || "";

    const $currentRowSlots = $(".js-timeout-puzzle-row")
      .eq(rowIndex)
      .find(".js-timeout-code-input-slot");

    $currentRowSlots.each((index, slotEl) => {
      const $slot = $(slotEl);
      const charVal = rowData.buffer[index]
        ? rowData.buffer[index].toLowerCase()
        : "";
      const targetChar = targetCode[index]
        ? targetCode[index].toLowerCase()
        : "";

      $slot.removeClass("is-correct-number is-wrong-number");

      if (charVal === targetChar && charVal !== "") {
        $slot.addClass("is-correct-number");
      } else {
        $slot.addClass("is-wrong-number");
      }
    });

    const answerCode = {
      [codeID]: answer,
    };

    if (answer === targetCode) {
      rowData.isCompleted = true;
      this.updateTimeoutCodeSlots();
      updateTimeoutBuildingBlockAnswers(blockID, answerCode).then(() => {
        this.maybeAllTimeoutCodesCompleted();
      });

      $currentRowSlots.addClass("is-correct-number");
    } else {
      rowData.attempts = Math.max(0, rowData.attempts - 1);
      $(this.elms.timeoutQuestionBox).addClass("is-incorrect");
    }
  }

  maybeAllTimeoutCodesCompleted() {
    const blockID = this._data.id;
    getTimeoutBuildingBlockAnswers(blockID).then((snapshot) => {
      const { correct_answers: codeAnswers } = getBuildingBlockAnswer(blockID);
      const timeoutAnswers = snapshot.val();

      if (
        !timeoutAnswers ||
        typeof timeoutAnswers !== "object" ||
        typeof codeAnswers !== "object"
      ) {
        return;
      }

      if (
        Object.keys(timeoutAnswers).length === Object.keys(codeAnswers).length
      ) {
        this.showCompletePopup();
      }
    });
  }

  showCompletePopup() {
    $(this.elms.inputAnswer).trigger("blur");
    $(this.elms.timeoutInputAnswer).trigger("blur");
    $(this.elms.completeOverlay).addClass("is-active");
  }

  onTeamComplete(e) {
    if (e) e.preventDefault();
    const $btn = $(this.elms.teamCompleteBtn);
    if ($btn.hasClass("is-loading")) return;

    $btn.addClass("is-loading");
    BD_GAME_LOGIC.goToDefaultNextBlock();
  }

  onTimeoutCloseError(e) {
    e.preventDefault();

    $(this.elms.timeoutQuestionBox).removeClass("is-incorrect");

    // Find first uncompleted timeout row and focus it
    const firstUncompletedIndex = this.timeoutRowsData.findIndex(
      (row) => !row.isCompleted,
    );
    this.timeoutActiveRowIndex =
      firstUncompletedIndex !== -1 ? firstUncompletedIndex : 0;

    const rowData = this.timeoutRowsData[this.timeoutActiveRowIndex];
    if (rowData) {
      let firstEmpty = rowData.buffer.indexOf("");
      rowData.cursorIndex =
        firstEmpty === -1 ? rowData.buffer.length - 1 : firstEmpty;
      $(this.elms.timeoutInputAnswer).val(rowData.buffer.join(""));
    }

    if ($(this.elms.timeoutInputAnswer)[0]) {
      $(this.elms.timeoutInputAnswer)[0].focus({ preventScroll: true });
    }
    this.updateTimeoutCodeSlots();
  }
}
